import React from 'react';
import PropTypes from 'prop-types';
import debounce from 'lodash/debounce';
import { AlertBase as Alert } from '@tfecom-thermofisher/react-komodo-design';

import Message from '../Message';

import './Notifications.scss';

const CLOSE_NOTIFICATION_AFTER_MS = 6000;

const Notification = ({
  config,
  removeNotification,
  delayMs = CLOSE_NOTIFICATION_AFTER_MS
}) => {
  const [canRemove, setCanRemove] = React.useState(true);
  const [className, setClassName] = React.useState('app-notification');

  const onMouseEnter = debounce(() => setCanRemove(false), 150);
  const onMouseLeave = debounce(() => setCanRemove(true), 150);

  React.useEffect(() => {
    const closeNotification = canRemove ? setTimeout(
      () => setClassName('app-notification fade-out-notification'),
      delayMs
    ) : null;

    if (!canRemove) {
      clearTimeout(closeNotification);
      setClassName('app-notification');
    }

    return () => clearTimeout(closeNotification);
  }, [canRemove, config, delayMs, removeNotification]);

  return (
    <span
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      className={className}
      onAnimationEnd={() => removeNotification(config)}
      data-testid="span-notification"
    >
      <Alert
        data-testid={`notification-${config.id}`}
        float
        white
        type={config.type}
        onClose={() => removeNotification(config)}
      >
        <Message message={config.message} values={config.values} />
      </Alert>
    </span>
  );
};

Notification.propTypes = {
  config: PropTypes.shape({
    id: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired,
    message: PropTypes.object.isRequired,
    values: PropTypes.object
  }).isRequired,
  removeNotification: PropTypes.func.isRequired,
  delayMs: PropTypes.number
};

export default Notification;
